module.exports = __webpack_public_path__ + "img/item2.1086f5a2.png";